/** Shell for /settings: breadcrumbs + close, left SettingsTree, right Outlet.
 *  Structure ported from dev SettingsLayout.tsx. */

import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';

import { Button } from '@/shared/ui/button';
import { useSettingsAccess } from './access';
import { SettingsBreadcrumbsWidget } from '@/widgets/settings-breadcrumbs';
import SettingsTree from './SettingsTree';

export default function SettingsLayout() {
  const navigate = useNavigate();
  const { hasAnyAccess } = useSettingsAccess();

  if (!hasAnyAccess) return <Navigate to="/" replace />;

  return (
    <div className="flex size-full flex-col bg-background">
      <div className="flex shrink-0 items-center justify-between gap-3 border-b border-border px-4 py-2">
        <SettingsBreadcrumbsWidget />
        <Button
          aria-label="Back to all agents"
          onClick={() => navigate('/')}
          variant="ghost"
          size="icon-sm"
        >
          <X />
        </Button>
      </div>
      <div className="flex min-h-0 grow overflow-hidden">
        <div className="shrink-0 overflow-y-auto border-r border-border">
          <SettingsTree />
        </div>
        <div className="min-w-0 grow overflow-y-auto px-6 pt-4 pb-12">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
